import React from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { z } from 'zod';
import formMessages from '../form-messages';
import { CircuitsFetched } from '~/generated';
import Spacings from '~/modules/ui-kit/spacings';
import messages from './messages';
import { useAppForm } from '../Form';

const schema = (intl: IntlShape) =>
  z.object({
    name: z
      .string({
        error: intl.formatMessage(formMessages.required),
      })
      .min(1, intl.formatMessage(formMessages.required)),
    circuit: z
      .string({
        error: intl.formatMessage(formMessages.required),
      })
      .min(1, intl.formatMessage(formMessages.required)),
    watchtowerId: z.string(),
  });

type CongregationFormProps = {
  circuits?: CircuitsFetched | null;
  onSubmit: (values: {
    name: string;
    circuit: number;
    watchtowerId?: string;
  }) => void;
  initialValues?: {
    name?: string;
    circuit?: number;
    watchtowerId?: string;
  };
  children?: React.ReactNode;
};

export const CongregationForm = (props: CongregationFormProps) => {
  const intl = useIntl();
  const form = useAppForm({
    defaultValues: {
      name: props.initialValues?.name || '',
      circuit: props.initialValues?.circuit?.toString() || '',
      watchtowerId: props.initialValues?.watchtowerId || '',
    },
    validators: {
      onChange: schema(intl),
    },
    onSubmit({ value }) {
      props.onSubmit({
        ...value,
        circuit: Number(value.circuit),
      });
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Spacings.Inset>
        <Spacings.Stack scale="l">
          <form.AppField name="name">
            {(field) => (
              <field.TextField
                label={<FormattedMessage {...messages.name} />}
              />
            )}
          </form.AppField>
          <form.AppField name="circuit">
            {(field) => (
              <field.SelectField
                label={<FormattedMessage {...messages.circuit} />}
                options={
                  props.circuits?.page?.items
                    ?.filter((c) => c?.id !== undefined)
                    .map((c) => ({
                      value: String(c!.id!),
                      label: c!.name ?? '',
                    })) ?? []
                }
              />
            )}
          </form.AppField>
          <form.AppField name="watchtowerId">
            {(field) => (
              <field.TextField
                label={<FormattedMessage {...messages.watchtowerId} />}
              />
            )}
          </form.AppField>
          {props.children}
          <div>
            <form.AppForm>
              <form.SubmitButton>
                <FormattedMessage {...formMessages.save} />
              </form.SubmitButton>
            </form.AppForm>
          </div>
        </Spacings.Stack>
      </Spacings.Inset>
    </form>
  );
};

export default CongregationForm;
